module.exports = __webpack_public_path__ + "img/airplay.a970588f.svg";